//helper
import Locale from "@/helper/locale/Locale.js";
//service
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';
import TransferMAAIService from '@/module/TransferMAAI/service/TransferMAAIService.js'  
import { CampaignType } from "@/helper/StaticValue.js";

/**
 * setup
 * @method initial
 * @method reinitial
 * setter
 * @method updateCampaignInfo
 * @method selectSubCampaign
 * @method setSelectedQuantity
 * event
 * @method onApiError
 * @method onApiSuccess
 */
export function DetailController () {
    this.lbl = Locale.getLbl();

    this.isLoading = false;
    this.campaignConfig = null;
    this.campaign = {};
    this.campaignId = null;
    this.type = '';
    this.point = 0;
    this.pointType = '';
    this.price = 0;
    this.originalPrice = 0;
    this.discount = 0;
    this.qty = 0;
    this.quantity = 0;
    this.isFavorite = false;
    //selected for redeem
    this.selectedCampaignId = null;
    this.selectedQuantity = 1;

    //#region setup
    /**
     * @param {CampaignConfigModel} campaignConfig /core/Campaign/model/CampaignConfigModel.js
     * @return Promise
     */
    this.initial = (campaignConfig) => {
        this.campaignConfig = campaignConfig;
        return this.getCampaignDetail();
    };
    this.reinitial = () => {
        this.lbl = Locale.getLbl();
        return this.getCampaignDetail();
    };
    //#endregion setup

    //#region setter
    this.updateCampaignInfo = () => {
        this.campaignId = this.campaign.id;
        this.selectedCampaignId = this.campaign.id;
        this.type = this.campaign.type;
        //this.point = this.campaign.pointPerUnit;
        
        if(this.campaign.type == CampaignType.Privilege20){
            this.point = this.campaign.maximumPartialPoints;
        }else{
            this.point = this.campaign.pointPerUnit;
        }

        this.pointType = this.campaign.pointType;
        this.price = this.campaign.pricePerUnit;
        this.originalPrice = this.campaign.originalPrice;
        this.discount = this.campaign.discount;
        this.qty = this.campaign.qty;
        this.quantity = this.campaign.quantity;
        this.isFavourite = this.campaign.isFavourite;
    };
    this.selectSubCampaign = selectedItem => {
        this.selectedCampaignId = selectedItem.id;
        this.type = selectedItem.type;
        this.point = selectedItem.pointPerUnit;
        this.price = this.campaign.pricePerUnit;
        this.originalPrice = this.campaign.originalPrice;
        this.discount = this.campaign.discount;
        this.quantity = selectedItem.quantity;
    };
    this.setSelectedQuantity = quantity => {
        this.selectedQuantity = quantity;
    };
    //#endregion setter

    //#region campaign
    this.getCampaignDetail = () => {
        return new Promise((resolve, reject) => {
            BzbsCampaign.apiGetCampaignDetail(this.campaignConfig).subscribe(async (campaign) => {
                this.campaign = campaign;
                this.updateCampaignInfo();
  
                if (campaign.isCampaignMAAI()) {
                    await this.checkIsMAAI();
                }
                resolve(campaign);
            }, (err) => {
                reject(err);
            });
        });
    };

    this.checkIsMAAI = () => {
        return new Promise((resolve) => {
            TransferMAAIService.checkIsMember().subscribe((res) => {
                this.campaign.isMAAIMember = res.success;
                //this.campaign.isMAAIMember = false;
                //console.log("isMAAIMember", this.campaign.isMAAIMember); 
                resolve(res);
            }, (err) => {
                console.log("err", err);
                resolve(false);
            });
        });
    };
    //#endregion campaign
}
